import React, { useState, useEffect } from "react";
import { StoreContext } from "../context/StoreContext";
import {
    Grid,
    Typography,
    Dialog,
    DialogTitle,
    Tabs,
    Tab
} from "@mui/material";
import CompanyAddEditForm from "./CompaniesAddEditForm";
import { ThemeProvider, useTheme } from "@mui/material";
import { DialogTheme } from "../styles/DialogTheme";
import { useAtom } from "jotai";
import { showCompanySettingsModalAtom } from "../atoms/atoms";
import { CompanySettingsTabValueAtom } from "../atoms/bookingFlowCustomization";
import { onSaveFunctionAtom } from "../atoms/atoms";
const CompanySettingsModal = ({ open, onClose = () => {} }) => {
    const { state } = React.useContext(StoreContext);
    const theme = useTheme();
    const [modalTitleCompanyName, setModalTitleCompanyName] = useState("");
    const [showCompanySettingsModal] = useAtom(showCompanySettingsModalAtom);
    const [tabValue, setTabValue] = useAtom(CompanySettingsTabValueAtom);
    const [onSaveFunction] = useAtom(onSaveFunctionAtom);
    function handleTabChange(event, newValue) {
        setTabValue(newValue);
    }

    const handleClose = () => {
        if (onSaveFunction?.fn) onSaveFunction.fn();
        setTabValue(0);
        onClose();
    };

    const assignModalTitleCompanyName = (companyName) => {
        setModalTitleCompanyName(companyName);
    };

    return (
        <ThemeProvider theme={DialogTheme(theme)}>
            <Dialog open={open} fullWidth maxWidth="lg" onClose={handleClose}>
                <DialogTitle
                    flexDirection={"column"}
                    sx={{
                        display: "flex",
                        alignItems: "flex-start",
                        padding: "36px 36px 0px 36px"
                    }}
                >
                    <Typography variant={"h3"}>
                        {state.mode === "Add"
                            ? `Add company`
                            : showCompanySettingsModal
                              ? `Settings`
                              : `Settings – ${modalTitleCompanyName}`}
                    </Typography>
                    {state.mode === "Edit" && (
                        <Grid container>
                            <Tabs
                                value={tabValue}
                                onChange={handleTabChange}
                                indicatorColor="primary"
                                textColor="primary"
                                variant="scrollable"
                                scrollButtons="auto"
                            >
                                <Tab label="Company" />
                                <Tab label="Configuration" />
                                <Tab label="Notifications" />
                                <Tab label="Online Bookings" />
                                <Tab label="Payments" />
                            </Tabs>
                        </Grid>
                    )}
                </DialogTitle>
                {
                    <CompanyAddEditForm
                        onClose={handleClose}
                        assignModalTitleCompanyName={
                            assignModalTitleCompanyName
                        }
                        tabValue={tabValue}
                    ></CompanyAddEditForm>
                }
            </Dialog>
        </ThemeProvider>
    );
};

export default CompanySettingsModal;
